const StepsWalked = () => ({
  value: 0
});

export default StepsWalked;
